module.exports = __webpack_public_path__ + "img/MX-C130086A-BS.dc1b2705.png";